const BOARD_SHAPE_ID_PATTERN = /^shape:[A-Za-z0-9_-]+$/;

const touchedShapes = new Set<string>();

export function isAgentBoardShapeId(value: unknown): value is string {
	return typeof value === "string" && BOARD_SHAPE_ID_PATTERN.test(value);
}

function addShapeId(ids: Set<string>, value: unknown) {
	if (isAgentBoardShapeId(value)) {
		ids.add(value);
	}
}

function addShapeIds(ids: Set<string>, value: unknown) {
	if (!Array.isArray(value)) {
		return;
	}

	for (const entry of value) {
		addShapeId(ids, entry);
	}
}

export function collectShapeIdsFromAgentTool(
	toolName: string,
	input: unknown,
	output: unknown,
): string[] {
	const ids = new Set<string>();
	const inputRecord =
		input && typeof input === "object"
			? (input as Record<string, unknown>)
			: {};
	const outputRecord =
		output && typeof output === "object"
			? (output as Record<string, unknown>)
			: {};

	addShapeId(ids, inputRecord.shapeId);
	addShapeIds(ids, inputRecord.shapeIds);
	addShapeId(ids, inputRecord.frameId);
	addShapeId(ids, inputRecord.sectionId);
	addShapeId(ids, inputRecord.fromShapeId);
	addShapeId(ids, inputRecord.toShapeId);
	addShapeId(ids, outputRecord.shapeId);
	addShapeIds(ids, outputRecord.shapeIds);
	addShapeId(ids, outputRecord.groupId);
	addShapeId(ids, outputRecord.sectionId);
	addShapeId(ids, outputRecord.preprintShapeId);
	addShapeIds(ids, outputRecord.preprintShapeIds);
	addShapeIds(ids, outputRecord.touchedShapeIds);

	if (toolName === "deleteShape" || toolName === "deleteCard") {
		const deletedShapeId =
			toolName === "deleteShape" ? inputRecord.shapeId : outputRecord.shapeId;
		return deletedShapeId && isAgentBoardShapeId(deletedShapeId)
			? [deletedShapeId]
			: [];
	}

	return [...ids];
}

export function recordAgentSessionTouchedShapes(shapeIds: string[]) {
	for (const shapeId of shapeIds) {
		if (isAgentBoardShapeId(shapeId)) {
			touchedShapes.add(shapeId);
		}
	}
}

export function removeAgentSessionTouchedShapes(shapeIds: string[]) {
	for (const shapeId of shapeIds) {
		touchedShapes.delete(shapeId);
	}
}

export function getAgentSessionTouchedShapes() {
	return [...touchedShapes];
}

export function clearAgentSessionTouchedShapes() {
	touchedShapes.clear();
}

export function resetAgentSessionTouchedShapesForTests() {
	touchedShapes.clear();
}
